import { COLORS, TYPE } from './tokens'
import SectionLabel from './SectionLabel'

// Inline "+ Add layer" reveal for portfolio-mode uploads.
export default function AddLayerAffordance({ expanded, onExpand, disabled }) {
  if (expanded) return null
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      marginTop: '40px', paddingTop: '20px',
      borderTop: `1px solid ${COLORS.hairline}`
    }}>
      <div style={{ maxWidth: '500px' }}>
        <SectionLabel variant="severity">Second policy · optional</SectionLabel>
        <p style={{ ...TYPE.body, color: COLORS.mutedText, marginTop: '8px' }}>
          For a stacked program, add the excess policy to run in portfolio mode.
        </p>
      </div>
      <button
        onClick={onExpand}
        disabled={disabled}
        style={{
          ...TYPE.supporting,
          padding: '8px 14px',
          background: 'transparent',
          color: COLORS.bodyText,
          border: `1px solid ${COLORS.hairline}`,
          borderRadius: '4px',
          cursor: disabled ? 'not-allowed' : 'pointer'
        }}
      >
        + Add layer
      </button>
    </div>
  )
}
